(function ($) {
	$(window).scroll(function () {
		$('header').toggleClass('is-sticky', $(document).scrollTop() > 210)
    });
})(jQuery);
